import brainImg from "../assets/stroke_and_damage_on_brain_finishedred+addedbackground1.webp";
import SEO from "../components/SEO";

export default function NotFound() {
  const notFoundSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Page Not Found - 404",
    "url": "https://www.thrombio.com.au/404",
    "mainEntity": {
      "@type": "Organization",
      "name": "Thrombio",
      "url": "https://www.thrombio.com.au/",
      "logo": "https://www.thrombio.com.au/thromBioInvert.png",
      "contactPoint": {
        "@type": "ContactPoint",
        "email": "info@thrombio.com.au"
      },
      "sameAs": [
        "https://www.linkedin.com/company/thrombioholdings"
      ]
    },
    "description": "The requested page could not be found on the ThromBio website. Navigate back to our homepage or explore our stroke research and drug development content."
  };

  return (
    <>
      <SEO
        title="Page Not Found - 404"
        description="The requested page could not be found. Return to ThromBio's homepage to explore our innovative stroke treatments and research."
        keywords={['404', 'Page Not Found', 'ThromBio', 'Stroke Research']} 
        ogImage={brainImg}
        schema={notFoundSchema}
      />

      <div className="bg-[#010C0E]/10">
        <div className="pt-[338px] md:pt-[120px] xl:pt-[95px] pb-40 md:pb-[32px] aboutHeroBg relative">
          <div className="grid md:grid-cols-2 xl:grid-cols-3 xl:items-center px-12 md:max-xl:px-[4rem] xl:page-width gap-8 md:gap-12">
            <div className="flex flex-col gap-[3.2rem]">
              <div className="font-sans text-[4.8rem] font-bold text-white leading-[5.2rem] tracking-[.192rem]">
                <h1 className="sr-only">404 - Page Not Found</h1>
                404
              </div>
              <div className="font-sans text-[3.2rem] font-bold text-white leading-[4.2rem] tracking-[.128rem] mb-4">
                Page Not Found
              </div>
              <p className="font-sans max-w-[542px] text-[2.1rem] leading-[3.1rem] tracking-[.042rem]">
                Sorry, the page you're looking for doesn't exist or has been moved.
              </p>
            </div>
            <img src={brainImg} alt="Blood clot in a brain vessel leading to brain damage diagram" className="max-md:hidden xl:col-span-2 md:w-[350px] xl:w-full" width={614} />
          </div>
        </div>
        <div className="aboutMissionBg">
          <div className="pt-12 pb-20"></div>
        </div>
      </div>
    </>
  );
}